import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import './VehicleStatus.css'
import ActionTypes from '../../store/actionTypes'
import { useNavigate } from 'react-router-dom'
import { fetchBreakdownTicketMap } from '../../store/actions/breakdownTickets'

const RenderVehicleAndCount = ({ isDashboard, vehicleCount, activeVehicleStatus, onActiveVechileStatusChange, filterVehicleData }) => {
    const navigate = useNavigate();
    const handleOnClick = (status) => {
        if (isDashboard) {
            if (onActiveVechileStatusChange) {
                onActiveVechileStatusChange(status)
            }
        } else {
            navigate("/")
            setTimeout(() => {
                if (onActiveVechileStatusChange) {
                    onActiveVechileStatusChange(status)
                }
            }, 300)
        }
    }
    const lableMap = {
        all: "All Vehicles",
        live: "Live Vehicles",
        parking: "Parked Vehicles",
        charging: "Charging Vehicles",
        nonCommunication: "Non Communicating Vehicles",
        favourite: "Favourite Vehicles",
        accident: "Accident Vehicles",
        breakdown: "Breakdown Vehicles",
    };
    return (
        Object.keys(vehicleCount).map(status => (
            <button
                key={`vehicle_count_${status}`}
                className={`dvs__vehicle-container ${status}-vehicle`}
                style={{ backgroundColor: activeVehicleStatus === status && !filterVehicleData.soc && !filterVehicleData.location ? '#EFF3F8' : 'transparent' }}
                onClick={() => handleOnClick(status)}
                title={lableMap[status]}
                data-testid={`header-vehicle-filter-button-${status}`}
            >
                <img className='dvs__vehicle-img' src={`images/svgicon/vehicleStatus/${status}.svg`} alt={status} />
                <p className='dvs__vehicle-count'>{vehicleCount[`${status}`]}</p>
                <div className={`dvs__vehicle-line-${status}`}></div>
            </button>
        ))
    )
}

const VehicleStatus = ({ isDashboard }) => {
    const dispatch = useDispatch()
    const vehicleData = useSelector(state => state.dashboardReducer.allDashboardVehicleData)
    const filterVehicleData = useSelector(state => state.dashboardReducer.filterVehicleData)
    const favouriteVehicle = useSelector(state => state.favoriteVehicle.favouriteVehicles)
    const breakdownTicketMap = useSelector(state => state.breakdownTickets.vehicleMap)
    const [vehicleCount, setVehicleCount] = useState({
        all: 0,
        live: 0,
        parking: 0,
        charging: 0,
        nonCommunication: 0,
        favourite: 0,
        accident: 0,
        breakdown: 0,
    })

    useEffect(() => {
        dispatch(fetchBreakdownTicketMap())
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        filterVehicleCountBasedOnStatus()
        // eslint-disable-next-line
    }, [vehicleData, favouriteVehicle, breakdownTicketMap])

    const filterVehicleCountBasedOnStatus = () => {
        const vehicleCountObj = JSON.parse(JSON.stringify(vehicleCount))
        vehicleCountObj.all = vehicleData.length
        vehicleCountObj.nonCommunication = vehicleData?.filter(fd => fd.ncom).length
        const communicatingVehicle = vehicleData?.filter(fd => !fd.ncom)
        vehicleCountObj.live = communicatingVehicle?.filter(fd => ["Live", "Idle"].includes(fd?.canStatus?.vs)).length;
        vehicleCountObj.parking = communicatingVehicle?.filter(fd => fd?.canStatus?.vs === "Parked").length;
        vehicleCountObj.charging = communicatingVehicle?.filter(fd => fd?.canStatus?.vs === "Charging").length;
        vehicleCountObj.favourite = favouriteVehicle?.length

        let accidentCount = 0
        let breakdownCount = 0
        if (breakdownTicketMap && Object.keys(breakdownTicketMap).length) {
            vehicleData.forEach(v => {
                const info = breakdownTicketMap[v.rn?.toUpperCase()]
                if (info?.hasAccident) accidentCount++
                if (info?.hasBreakdown) breakdownCount++
            })
        }
        vehicleCountObj.accident = accidentCount
        vehicleCountObj.breakdown = breakdownCount

        setVehicleCount({ ...vehicleCountObj })
    }

    const handleActiveVehicleStatus = (status) => {
        dispatch({ type: ActionTypes.DASHBOARD.SET_TOP_PANEL_VEHICLE_STATUS, payload: status })
    }

    return (
        <div className='dashboard-vehicle-status'>
            <RenderVehicleAndCount isDashboard={isDashboard} vehicleCount={vehicleCount} activeVehicleStatus={filterVehicleData.topPanelQuery} filterVehicleData={filterVehicleData} onActiveVechileStatusChange={handleActiveVehicleStatus} />
        </div>
    )
}

export default VehicleStatus